import templates from './components/material-pricing/templates';
export default function ($templateCache) {
  "ngInject"
  console.log('run func', templates);
  for (let prod in templates) {
    let prodTemplates = templates[prod];
    for (let material in prodTemplates) {
      //console.log(material, `${prod}-${material}.html`);
      $templateCache.put(`${prod}-${material}.html`, templates[prod][material]);
    }
  }
}


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/modules/products/run.js
 **/